import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useTranslation } from 'react-i18next';
import PqrsHelpModal from 'components/pqrs/PqrsHelpModal';

/**
 * Botón "¿Necesitas ayuda?" que abre el modal para crear una PQRS. Reutilizable en Inicio y en la
 * creación de agenda. Variante `text` por defecto (acento dorado) para no competir con el CTA.
 */
function HelpButton({ variant = 'text', size = 'small', sx = {} }) {
  const { t } = useTranslation(['pqrs']);
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant={variant}
        size={size}
        color="inherit"
        startIcon={<HelpOutlineIcon fontSize="small" />}
        onClick={() => setOpen(true)}
        sx={{ color: 'gold.main', textTransform: 'none', fontWeight: 700, ...sx }}
      >
        {t('helpButton', { ns: 'pqrs', defaultValue: '¿Necesitas ayuda?' })}
      </Button>
      <PqrsHelpModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}

HelpButton.propTypes = {
  variant: PropTypes.string,
  size: PropTypes.string,
  sx: PropTypes.object
};

export default HelpButton;
